(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function firstSummitSwipeSupport() {
  const init = () => {
    const root = document.querySelector('[data-fs-home]');
    if (!root || root.dataset.fsSwipeReady === 'true') return;
    root.dataset.fsSwipeReady = 'true';

    const hero = root.querySelector('[data-fs-hero]');
    if (hero) {
      hero.style.touchAction = 'pan-y';
      let startX = 0, startY = 0, active = false;
      hero.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        startX = e.clientX; startY = e.clientY; active = true;
      });
      hero.addEventListener('pointerup', (e) => {
        if (!active) return;
        active = false;
        const dx = e.clientX - startX, dy = e.clientY - startY;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
        const selector = dx < 0 ? '[data-fs-hero-next]' : '[data-fs-hero-prev]';
        root.querySelector(selector)?.click();
      });
      hero.addEventListener('pointercancel', () => active = false);
    }

    const track = root.querySelector('[data-fs-marquee-track]');
    if (track) {
      track.style.touchAction = 'pan-y';
      track.style.cursor = 'grab';
      let startX = 0, startY = 0, base = 0, offset = 0, dragging = false, moved = false;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        startX = e.clientX; startY = e.clientY; base = offset; dragging = true; moved = false;
        track.style.cursor = 'grabbing';
      });
      track.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX, dy = e.clientY - startY;
        if (Math.abs(dx) < 4 || Math.abs(dx) <= Math.abs(dy)) return;
        moved = true; offset = base + dx;
        track.style.translate = offset + 'px 0';
        if (track.setPointerCapture) { try { track.setPointerCapture(e.pointerId); } catch (_) {} }
      });
      const finish = () => { dragging = false; track.style.cursor = 'grab'; };
      track.addEventListener('pointerup', finish);
      track.addEventListener('pointercancel', finish);
      track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
